/**
 * The id of the row's bid `<form>`, so a control outside it can still submit.
 */
export const getBidFormId = (listingId: string) => `bid-form-${listingId}`
